import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import {
  type RequestsKind,
  StudentsWaitingPage,
  type WaitingTabKey,
} from '@/admin/waiting/StudentsWaitingPage';

const TABS: WaitingTabKey[] = [
  'waiting',
  'grades',
  'requests',
  'hopeful',
  'adoptions',
];
const KINDS: RequestsKind[] = ['switch', 'adoption', 'history'];

// Each tab's table keeps its own `<tab>_page|q|sort|order|filters` keys in the
// URL (createTablePage's searchPrefix), so they must survive validation.
const TABLE_KEY =
  /^(waiting|grades|requests|hopeful|adoptions)_(page|q|sort|order|filters)$/;

// Optional in the type so a link may name just one of them.
type Search = { tab?: WaitingTabKey; kind?: RequestsKind } & Record<
  string,
  unknown
>;

export const Route = createFileRoute('/admin/students-waiting')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  validateSearch: (search: Record<string, unknown>): Search => {
    const tab = TABS.find((t) => t === search.tab) ?? 'waiting';
    const kind = KINDS.find((k) => k === search.kind) ?? 'switch';
    const tableKeys = Object.fromEntries(
      Object.entries(search).filter(([key]) => TABLE_KEY.test(key)),
    );
    return { ...tableKeys, tab, kind };
  },
  component: Page,
});

function Page(): ReactElement {
  const { tab = 'waiting', kind = 'switch' } = Route.useSearch();
  return <StudentsWaitingPage tab={tab} kind={kind} />;
}
